import { COLORS } from '@/constants';
import { Button } from '@mui/material';
import styled from 'styled-components';

export const Container = styled.div`
  margin: 0 auto;
  max-width: 100%
  display: flex;
  height: fit-content;
  z-index: 10;
  position: relative;
  @media (max-width: 800px) {
    padding-bottom: 50px
  };

  .swiper {
    width: 100%;
    height: fit-content;
    margin: 0;
  };

  .mySwiper {
    width: 100%;
  };

  .swiper-slide {
    background-color: transparent !important;
    height: auto;
  };

  /* The card's bottom border is drawn by its content flush with the card's
     own rounded overflow clip; during async scroll Firefox snaps that clip
     a device pixel higher and the straight edge disappears. */
  .mySwiper > .swiper-wrapper > .swiper-slide > .MuiCard-root {
    overflow: visible;
  }

`;

export const StyledButton = styled(Button)`
  width: 36px;
  height: 36px;
  min-height: 36px;
  min-width: 36px !important;
  max-width: 36px;
  max-height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${COLORS.orange} !important;
  border-color: ${COLORS['blue-light-2']} !important;
  background: ${COLORS.white} !important;
  border-radius: 50% !important;
  border-width: 2px !important;

  svg {
    min-width: 16px;
    min-height: 16px;
  }
  &:disabled {
    opacity: 0.4;
  }
`;

export const StaticGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  width: 100%;

  @media (max-width: 960px) {
    grid-template-columns: repeat(2, 1fr);

    > *:nth-child(3) {
      display: none;
    }
  }

  @media (max-width: 800px) {
    grid-template-columns: 1fr;

    > *:nth-child(2) {
      display: none;
    }
  }
`;

export const SkeletonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  width: 100%;

  @media (max-width: 960px) {
    grid-template-columns: repeat(2, 1fr);

    > *:nth-child(3) {
      display: none;
    }
  }

  @media (max-width: 800px) {
    grid-template-columns: 1fr;

    > *:nth-child(2) {
      display: none;
    }
  }
`;

export const ControlsBox = styled.div`
  display: flex;
  gap: 28px;
  position: absolute;
  right: 0;
  top: -66px;
  @media (max-width: 800px) {
    top: auto;
    left: 0;
    bottom: 0px;
    justify-content: center;
  }
`;
